import { ref, watch } from 'vue'
// 单纯为了把ref和watch写在一起
export default (
  { get, commit }: any,
  val = ref(),
  options = undefined as any
): any => {
  val.value = get()
  watch(val, commit, options)
  return val
}
